import React from 'react'
import { Modal, Button, Badge } from 'react-bootstrap'

function ChangelogModal({ show, onClose, versionInfo }) {
    if (!versionInfo) {
        return null
    }

    const { version, changelog, forceReset, softReset } = versionInfo

    const handleAcknowledge = () => {
        onClose()
    }

    // Simple markdown-like formatting
    const formatChangelog = (text) => {
        if (!text) return null

        return text.split('\n').map((line, idx) => {
            // Headers (##)
            if (line.trim().startsWith('## ')) {
                return (
                    <h5 key={idx} className="mt-3 mb-2 border-bottom pb-2">
                        {line.replace('## ', '')}
                    </h5>
                )
            }
            // List items (-)
            if (line.trim().startsWith('- ')) {
                const content = line.replace(/^- /, '')
                // Handle bold text (**text**)
                const parts = content.split(/(\*\*.*?\*\*)/)
                return (
                    <li key={idx}>
                        {parts.map((part, i) =>
                            part.startsWith('**') && part.endsWith('**') ? (
                                <strong key={i}>{part.slice(2, -2)}</strong>
                            ) : part
                        )}
                    </li>
                )
            }
            // Empty lines
            if (line.trim() === '') {
                return <div key={idx} style={{ height: '0.5rem' }} />
            }
            // Regular text
            return <p key={idx} className="mb-1">{line}</p>
        })
    }

    return (
        <Modal show={show} onHide={handleAcknowledge} size="lg" backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    The version was updated - What&apos;s New in v{version}
                    {forceReset && (
                        <Badge bg="warning" text="dark" className="ms-2">
                            Settings Reset Required
                        </Badge>
                    )}
                    {softReset && !forceReset && (
                        <Badge bg="info" className="ms-2">
                            Table Settings Refreshed
                        </Badge>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {forceReset && (
                    <div className="alert alert-warning mb-3">
                        <i className="bi bi-exclamation-triangle me-2"></i>
                        <strong>Important:</strong> This update requires clearing cached settings. You will remain logged in.
                    </div>
                )}
                {softReset && !forceReset && (
                    <div className="alert alert-info mb-3">
                        <i className="bi bi-info-circle me-2"></i>
                        <strong>Note:</strong> This update includes new table columns. Your table display settings have been refreshed to show the latest columns.
                    </div>
                )}

                <div>
                    {formatChangelog(changelog)}
                </div>

                <div className="mt-4 pt-3 border-top text-muted">
                    <small>Released: {versionInfo.buildDate}</small>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleAcknowledge}>
                    {(forceReset || softReset) ? 'Reload Application' : 'Got it!'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ChangelogModal
